/**
 * # Eurail Payment Input Page Hooks
 *
 *
 */
import { SearchItem } from '@yiluhub/yilu-amp-types';
import { useCurrentProduct } from 'hooks/index';
import { useEffect, useMemo, useRef } from 'react';
import { useLocation } from 'react-router-dom';

import { yiluTracking } from 'utils/index';

import { useEurailProductSummaryProps } from 'modules/eurail/pages/PaymentInputPage/hooks/useEurailProductSummaryProps';
import { usePaymentInfoFormProps } from 'modules/eurail/pages/PaymentInputPage/hooks/usePaymentInfoFormProps';

import { getEurailPaymentInputPageQueryParams } from '../../../utils/query-params';

/**
 * Retrieve data for the Eurail payment input page.
 */
export const useEurailPaymentInputPage = () => {
  const location = useLocation();

  const eurailPaymentInputPageQueryParams = useMemo(() => {
    return getEurailPaymentInputPageQueryParams(location);
  }, [location]);

  const { currentProduct } = useCurrentProduct(eurailPaymentInputPageQueryParams.searchResultID);
  const currentEurailPass = currentProduct as SearchItem | undefined;
  const paymentFormRef = useRef<HTMLFormElement>(null);

  const isPageReady = Boolean(currentProduct);

  useEffect(() => {
    if (!isPageReady) {
      return;
    }

    yiluTracking.sendGAEvent({
      event: 'page_loaded',
      category: 'eurail-pip',
      label: 'eurail_pip_loaded',
    });
  }, [isPageReady]);

  const paymentInformationFormProps = usePaymentInfoFormProps(
    currentEurailPass,
    paymentFormRef,
    eurailPaymentInputPageQueryParams,
  );

  const eurailProductSummaryProps = useEurailProductSummaryProps(currentEurailPass, paymentFormRef);

  return {
    isPageReady,
    paymentInformationFormProps,
    eurailProductSummaryProps,
  };
};
